"use client";

import React, { useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import {Autoplay, Navigation} from 'swiper/modules';
import 'swiper/css';
import { CircleChevronLeft, CircleChevronRight } from 'lucide-react';
import { SwiperOptions } from 'swiper/types';

export interface CustomSwiperProps {
    children: React.ReactNode;
    sliderSettings?: SwiperOptions | undefined;
    showArrow?: boolean;
    customArrow?: boolean;
    title?: string;
    subtitle?: string;
    className?: string;
}

const CustomSwiper = ({
                          children,
                          sliderSettings,
                          showArrow,
                          customArrow = false,
                          title,
                          subtitle,
                          className,
                      }: CustomSwiperProps) => {
    const prevRef = useRef(null);
    const nextRef = useRef(null);

    const defaultSettings = {
        slidesPerView: 3,
        spaceBetween: 20,
        modules: [Navigation, Autoplay],
        navigation: {
            prevEl: prevRef.current,
            nextEl: nextRef.current,
        },
        onSwiper: (swiper: any) => {
            if (!swiper.params.navigation) {
                swiper.params.navigation = {};
            }
            swiper.params.navigation.prevEl = prevRef.current;
            swiper.params.navigation.nextEl = nextRef.current;
            swiper.navigation.init();
            swiper.navigation.update();
        },
        ...sliderSettings,
    };

    return (
        <>
            <div className={`relative w-full max-w-7xl mx-auto flex my-4 justify-between items-center`}>
                <div className="flex flex-col">
                    <h2 className="text-3xl max-sm:px-2 font-normal">{title}</h2>
                    <h3 className="text-xl max-sm:px-2  font-normal">{subtitle}</h3>
                </div>

                {showArrow && (
                    <div className={`flex max-sm:hidden `}>
                        <CircleChevronLeft className="cursor-pointer" strokeWidth={0.5} ref={prevRef} size={40}/>
                        <CircleChevronRight className="cursor-pointer" strokeWidth={0.5} ref={nextRef} size={40}/>
                    </div>
                )}
            </div>
            <div className="relative">
                {customArrow && (
                    <>
                        <div ref={prevRef}
                             className="absolute left-10 top-1/2 max-sm:hidden transform -translate-y-1/2 z-10 cursor-pointer">
                            <CircleChevronLeft size={40} strokeWidth={0.5}/>
                        </div>
                        <div ref={nextRef}
                             className="absolute right-10 top-1/2 max-sm:hidden transform -translate-y-1/2 z-10 cursor-pointer">
                            <CircleChevronRight size={40} strokeWidth={0.5}/>
                        </div>
                    </>
                )}
                <Swiper {...defaultSettings}>
                    {children}
                </Swiper>
            </div>
        </>
    );
};

export default CustomSwiper;
